
import clientProviderFullcont       from "./clientProvider-fullcont.html";

const dialog          = require ('../../../../../components/dialog/dialog')
const fullcontEntity  = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require ('../../../../../components/fullcont/fullcont-handler')

const {formCopy}      = require('./clientProvider-fullcont-form') 
const {form}          = require('./clientProvider-fullcont-form')
const handler         = require('./clientProvider-fullcont-handler')
// const {clientProviderMT}      = require('./clientProvider-fullcont-multitable')

//const clientProviderMT        = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(
            'provider','clientProvider', 'clientProvider-fullcont', 
            clientProviderFullcont, form, formCopy, undefined, 
            editDialog, deleteDialog, undefined, htmlFc)

	HTMLwasSelected   = true             
}/**/




export function start(detail){  //console.log('clientProvider-fullcont >', detail)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/


const obj = {

      cancelEdit:            { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                }},
      deleteEntity:          { start: (detail)=>{  fullcontEntity.deleteEntity(detail, htmlFc)              }},
      deleteFromDialog:      { start: (detail)=>{  fullcontEntity.deleteFromDialog(detail, htmlFc)          }},
      discard:               { start: (detail)=>{  fullcontHandler.discard(detail, htmlFc)                  }},
      hide:                  { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                      }},
      prepareEdit:           { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)              }},
      saveFromDialog:        { start: (detail)=>{  fullcontEntity.saveFromDialog(detail, htmlFc)            }},
      selectOne:             { start: (detail)=>{  fullcontEntity.selectOne(detail, htmlFc, processSelectOne)                 }},
      update:                { start: (detail)=>{  fullcontEntity.update(detail, htmlFc)                    }},
      show  :                { start: (detail)=>{  htmlFc.fullcontHTML.classList.add('fullcont-show')       }},
      complete_bill_to_ship: { start: (detail)=>{  handler.complete_bill_to_ship(htmlFc)                    }},

      

      //fullcontOptions:  { start: (detail)=>{  clientProviderMenu.start(detail, 'htmlDt', htmlFc )                }},

}/**/



function processSelectOne (data){
      console.log(data)
}


//function to send
function editDialog(){
		dialog.start({ act:"show", id:"saveChanges", entity:'clientProvider' } )
}

function deleteDialog(detail){
		dialog.start({ act:"show", id:"deleteElem", entity:'clientProvider', dbid: detail.dbid } )
}

// function dtCall(act, result){ 
// 		clientProviderDt.start({act:act, row: result})
// }


